import {combineReducers} from 'redux';

import { AuthReducer } from './reducers/AuthReducer';
import { BucketReducer } from './reducers/BucketReducer';
import { UsersReducer } from './reducers/UsersReducer';
import { ClientsReducer } from './reducers/ClientsReducer';
import { ClientSubcontractorsReducer } from './reducers/ClientSubcontractorsReducer';
import { ClientSubcontractedReducer } from './reducers/ClientSubcontractedReducer';
import { EmployersReducer } from './reducers/EmployersReducer';
import { EmployerWorksitesReducer } from './reducers/EmployerWorksitesReducer';
import { EmployeesReducer } from './reducers/EmployeesReducer';
import { EmployeeCoursesReducer } from './reducers/EmployeeCouresReducer';
import { EquipmentReducer } from './reducers/EquipmentReducer';
import { AuthorizationsISCIRReducer as AuthorizationsReducer } from './reducers/AuthorizationsReducer';
import { RemindersReducer } from './reducers/RemindersReducer';
import { RsvtiTasksReducer } from './reducers/RsvtiTasksReducer';
import { StaticDataReducer } from './reducers/StaticDataReducer'
import { RsvtiOperatorsReducer } from './reducers/OperatorsReducer';

import * as ActionTypes from './ActionTypes';


const allReducers = combineReducers({
    auth: AuthReducer,
    bucket: BucketReducer,
    users: UsersReducer,
    clients: ClientsReducer,
    clientSubcontractors: ClientSubcontractorsReducer,
    clientSubcontracted: ClientSubcontractedReducer,
    employers: EmployersReducer,
    worksites: EmployerWorksitesReducer,
    employees: EmployeesReducer,
    employeeCourses: EmployeeCoursesReducer,
    authorizations: AuthorizationsReducer,
    rsvtiOperators: RsvtiOperatorsReducer,
    reminders: RemindersReducer,
    equipment: EquipmentReducer,
    rsvtiTasks: RsvtiTasksReducer,
    staticData: StaticDataReducer
});


export const RootReducer = (state, action) => {
    if(action.type === ActionTypes.RESET_STATE_ON_LOGOUT) {
        state = undefined;
    }

    return allReducers(state, action);
}
